
<template>
  <div class="list">
    <van-nav-bar
      title="考试列表"
      left-arrow
      fixed
      @click-left="back"
    />
    <van-empty v-if="!divshow&&this.tasklist.length ==0" description="暂无数据" />
    <van-row   class="bitem" justify="space-between"  v-if="divshow">
      <van-col span="18">
        <h4>{{ data.paperDesc }} ( {{ paperValue}}分)</h4>
        <p>考试时间：{{ data.kstarttime }} ~ {{ data.kendtime }}</p>
        <p>考试时长：{{ data.exam_time }}</p>
      </van-col>
      <van-col span="5">
        <span :class="data.ssjj != 'Y' ? 'ing' : 'end'">{{ data.ssjj=='Y'?'已完成考试':'正在考试...' }}</span>
      </van-col>
      <van-col span="24">
        <div
          v-if="data.ssjj != 'Y' && isks"
          class="enter"
          @click="kaoshi"
        >进入考试<van-icon name="arrow" />
        </div>
        <div v-if="!isks"  class="enter"
        >{{msgmx}}
        </div>
      </van-col>
    </van-row>
    <van-row  v-for="(item,index) in tasklist" :key="'tasklist'+index" class="bitem" justify="space-between">
      <van-col>
        <h4>{{ item.paperDesc }} ( {{ item.paperValue}}分)</h4>
        <p>考试时间：{{ item.starttime }} ~ {{ item.endtime }}</p>
        <p>考试时长：{{ item.examTime }}</p>
      </van-col>
    </van-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '考试列表',
      list: [],
      olist: [],
      serachText: '',
      isks:false,
      kssc: '',
      kssj: '',
      msgmx:'',
      data:{},
      paperValue:0,
      issj:false,
      tasklist:[],
      divshow:true,
    };
  },
  created: function() {
    localStorage.setItem("currentpath",this.$router.currentRoute.fullPath);
    this.getstudent()

  },
  methods: {
    getstudent() {
      let that = this;
      this.$ajax.get('/student/examonline/studenttask').then(function (res) {
        if (res.code == 200) {
          that.data = res.data;
          console.log(that.data);
          that.kssc = "试卷时长：" + that.data.exam_time + " 分钟"
          that.kssj = "考试时间：" + that.data.kstarttime + " - " + that.data.kendtime
          that.paperValue = that.data.paperinfo.paperValue
          if ("Y" == that.data.ssjj) {
            that.kssj = "已完成考试";
          } else {
            that.isks = true;
          }
          that.issj = true;
        } else {
          that.msgmx = res.msg;
          that.isks = false;
        }
        if (res.code == 401) {
          location.href = '/login';
        }
        if (res.code == 500) {
          that.divshow = false;
        }
      })

      this.$ajax.get('/student/examonline/studenttaskall').then(function (res) {
        if (res.code == 200) {
          that.tasklist = res.data.taskall;
        }
        if (res.code == 401) {
          location.href = '/login';
        }
      })
    },
    kaoshi() {
      let that =this
      this.$ajax.get('/student/examonline/studenttask').then(function(res) {
        if (res.code == 200) {
          if (res.data.ssjj == 'Y') {
            that.$toast.fail('已经考过，不能进入考试！');
          } else {
            that.$router.push({ name: 'kaikao', params: { id: res.data.ksmxid} });
          }
        }
        if(res.code == 401)
        {
          location.href = '/login';
        }
      })
    },
    back() {
      console.log('back');
      this.$router.push("/studentmain")
    }
  },
  watch: {
    serachText(newText, oldText) {
      this.list = this.U.checkItemsFromArrays(newText, this.olist, ['KCMC', 'KKYXMC']);

    }
  }
};
</script>
<style lang="scss" scoped>
  .list{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .bitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/kaoshi/kaoshi.vue